import { FC, PropsWithChildren } from 'react';
import Modal from '@ingka/modal';

export const ModalWrapper: FC<
  PropsWithChildren<{
    visible: boolean;
    handleDismiss: () => void;
  }>
> = ({ children, handleDismiss, visible }) => {
  return (
    <Modal visible={visible} handleCloseBtn={handleDismiss} className="z-50">
      {/* @ts-ignore */}
      {children}
    </Modal>
  );
};
